module.exports = "../../app/cells/components/google_one_tap_auth/show.erb";